import {
  Container,
  Grid,
  Typography,
  makeStyles,
  Box,
  Paper,
  useTheme,
  Button,
  Slide,
  CircularProgress,
} from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import AppBar from "../../components/Frontend/AppBar/AppBar";
import { withRouter } from "react-router-dom";
import AxiosErrorHandling from "../../components/AxiosErrorHandling/AxiosErrorHandling";
import { DetectWelcomeMessage } from "../../config/dashboardConfigData";
import Submitted from "../../Assets/Images/ThankYouCompany.png";

const calcBackground = (type, selected) => {
  if (type === "positive") return selected ? "#06681E" : "#16C542";
  else return selected ? "#8F0A0A" : "#E51010";
};

const ResponseButton = styled(({ type, ...other }) => <Button {...other} />)({
  background: (props) => calcBackground(props.type, props.selected),
  border: 0,
  color: "white",
  height: 48,
  padding: "0 30px",
  margin: 8,
  borderRadius: "8px",
  boxShadow: "none",
  opacity: (props) => (props.withppacitiy === "true" ? 0.3 : 1),
  "&:hover": {
    backgroundColor: (props) =>
      props.type === "positive" ? "#06681E" : "#8F0A0A",
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F5F6F8",
    margin: "0 auto",
    minHeight: "100vh",
    position: "relative",
  },
  bold: {
    fontWeight: 700,
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "16px",
  },
  buttonReady: {
    background: "#fff",
    boxShadow:
      "0px -6px 116px rgba(164, 166, 179, 0.21), 0px -1.81px 34.9706px rgba(164, 166, 179, 0.136834), 0px -0.75px 14.525px rgba(164, 166, 179, 0.105), 0px -0.27px 5.25341px rgba(164, 166, 179, 0.0731663)",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const CompanySignalResponse = (props) => {
  const classes = useStyles();
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [submittedSuccessfully, setSubmittedSuccessfully] = useState(false);
  useEffect(() => {
    async function validateCompany() {
      try {
        const company = await axios.get(
          `/wp-json/api/v2/signal_welcome/${props.match.params.token}`
        );
        setCompanyData(company.data);
      } catch (err) {
        setError(err.response ? err.response : err);
      }
    }
    validateCompany();
  }, [props.match.params.token]);

  const handleSendCategories = async () => {
    setButtonLoading(true);
    try {
      await axios.post(
        "wp-json/api/v2/company_signal_reponse",
        {
          categories: selectedCategories,
        },
        {
          headers: {
            Authorization: `Bearer ${props.match.params.token}`,
          },
        }
      );
      setButtonLoading(false);
      setSubmittedSuccessfully(true);
    } catch (err) {
      setButtonLoading(false);
      setSubmittedSuccessfully(false);
      setError(err.response);
    }
  };

  const handleSelectCategory = (id, value) => {
    console.log(id, value);
    if (value) {
      if (!selectedCategories.includes(id))
        setSelectedCategories((prev) => [...prev, id]);
    } else {
      if (selectedCategories.includes(id)) {
        if (selectedCategories.length === 1) {
          setSelectedCategories([]);
          return;
        }
        const newCats = selectedCategories;
        const ind = newCats.findIndex((cat) => cat === id);
        if (ind > -1) {
          newCats.splice(ind, 1);
          setSelectedCategories(newCats);
        }
      }
    }
  };
  return (
    <React.Fragment>
      <Container maxWidth={"sm"} disableGutters className={classes.root}>
        <AppBar />
        <Grid container>
          <Grid item xs={12}>
            <Box px={2} py={4}>
              {error && (
                <AxiosErrorHandling
                  title="Oh No! something went wrong..."
                  error={error}
                />
              )}
              {submittedSuccessfully ? (
                <ConfirmationPage
                  fullname={companyData && companyData.fullname}
                />
              ) : (
                <Fragment>
                  <Typography variant="body1" paragraph>
                    <span className={classes.bold}>
                      {DetectWelcomeMessage()}{" "}
                      {companyData && companyData.fullname}
                    </span>
                    , How are you doing? <br />
                    As requested, we have found you new candidates:
                  </Typography>
                  <Box pb={2}>
                    {companyData &&
                      companyData.categories_data.map((category) => {
                        return (
                          <CategoryItem
                            category={category}
                            key={category.id.toString()}
                            onSelect={handleSelectCategory}
                          />
                        );
                      })}
                  </Box>
                  <Slide
                    direction="up"
                    in={selectedCategories.length > 0}
                    mountOnEnter
                    unmountOnExit
                  >
                    <Box
                      width="100%"
                      className={classes.buttonReady}
                      p={2}
                      textAlign="center"
                    >
                      <Typography variant="body1" paragraph>
                        Have you selected all the categories you need employees
                        for?
                      </Typography>
                      <div className={classes.wrapper}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSendCategories}
                          disabled={buttonLoading}
                        >
                          Yes, I'm ready
                        </Button>
                        {buttonLoading && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </div>
                    </Box>
                  </Slide>
                </Fragment>
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};
export default withRouter(CompanySignalResponse);

const CategoryItem = ({ category, onSelect }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [active, setActive] = useState("");

  const handleSelectCategory = (type) => {
    const currActive = active;
    setActive((prev) => (prev === type ? "" : type));
    onSelect(category.id, type === "positive" && currActive === "");
  };

  return (
    <Fragment>
      <Box mb={2}>
        <Paper className={classes.paper}>
          <Box display={"flex"} alignItems="center" mb={2}>
            <img
              src={category.icon}
              alt={category.name}
              style={{ marginRight: theme.spacing(2) }}
            />
            <Typography variant="h6">{category.name}</Typography>
          </Box>
          <Box
            display={"flex"}
            justifyContent="space-between"
            alignItems={"cener"}
          >
            <ResponseButton
              variant="contained"
              type="positive"
              selected={active === "positive"}
              withppacitiy={active === "negative" ? "true" : "false"}
              onClick={() => handleSelectCategory("positive")}
            >
              Yes, I need
            </ResponseButton>
            <ResponseButton
              variant="contained"
              type={"negative"}
              selected={active === "negative"}
              withppacitiy={active === "positive" ? "true" : "false"}
              onClick={() => handleSelectCategory("negative")}
            >
              Not today
            </ResponseButton>
          </Box>
        </Paper>
      </Box>
    </Fragment>
  );
};

const ConfirmationPage = ({ fullname }) => {
  const theme = useTheme();
  return (
    <Slide in={true} direction="left">
      <Box
        py={4}
        px={2}
        display="flex"
        alignItems={"center"}
        flexDirection="column"
      >
        <img
          src={Submitted}
          alt="submitted successfuly"
          style={{ maxWidth: "100%", marginBottom: theme.spacing(4) }}
        />
        <Typography
          variant="h6"
          textAlign="center"
          paragraph
        >{`Thank you, ${fullname}`}</Typography>
        <Typography variant="body1" paragraph>
          Your request has been successfully submitted. One of us will contact
          you shortly.
        </Typography>
        <Button variant="contained" color="primary">
          To Personal Account
        </Button>
      </Box>
    </Slide>
  );
};
